<template>
  <v-row dense>
    <v-col cols="12">
      <v-card
        tile
        color="primary"
        class="elevation-0 mb-2"
      >
        <v-card-title
          class="font-weight-medium grey--text pt-1 pb-2"
        >
          {{ title }}
        </v-card-title>
        <v-card-subtitle class="pb-2">
          {{ subtitle }}
        </v-card-subtitle>
      </v-card>

      <v-card class="elevation-0 mt-3" tile>
        <h5>Backoffice seguridad.</h5>
      </v-card>
    </v-col>
  </v-row>
</template>

<script>
export default {
  name: 'Dashboard',
  data() {
    return {
      title: 'Dashboard',
      subtitle: 'Sistema de control de acceso a la propiedad',
    };
  },
};
</script>



// WEBPACK FOOTER //
// src/views/Dashboard.vue